export default {
  CURRENCY_RATES(state, resp) {
    state.currencyRates = resp.data;
  },
};
